import { createSlice } from "@reduxjs/toolkit";


export const InitialHomeState = {
    shopProductList: [],
    pageNo: 0,
    currentUrl: ""
};

const shopSlice = createSlice({
    name: "shop",
    initialState: InitialHomeState,
    reducers: {

        setShopProductList(state, { payload }) {
            state.shopProductList = payload;
        },
        addMoreShopProductList(state, { payload }) {
            state.shopProductList = [...state.shopProductList, ...payload];
        },

        setPageNo(state, { payload }) {
            state.pageNo = payload;
        },
        addPageNo(state) {
            state.pageNo = state.pageNo + 1;
            return state;
        },
        setCurrentUrl(state, { payload }) {
            state.currentUrl = payload;
        },
    }
});


export const shopActions = shopSlice.actions;
export default shopSlice;